import React from 'react';
import { Box, Paper, Text } from '@mantine/core';
import cn from 'classnames';

import type { AssistantChatMessage } from '../../controllers/AssistantChatController';
import { AssistantMarkdown } from './AssistantMarkdown';
import classes from './AssistantChat.module.css';

/**
 * Карточка одного сообщения чата — без ролевого лейбла и времени: отправителя видно по
 * выравниванию и фону (справа/синий — пользователь, слева/серый — ассистент).
 * Мемоизирована: при стриме меняется только последний элемент массива сообщений,
 * поэтому ререндерится одна карточка, а не вся история.
 */
export const AssistantMessageCard = React.memo(function AssistantMessageCard({
  message,
}: {
  message: AssistantChatMessage;
}) {
  const isUser = message.role === 'user';
  return (
    <Paper
      p='xs'
      withBorder
      bg={isUser ? 'blue.0' : 'gray.0'}
      className={cn(classes.messageCard, isUser && classes.messageCardUser)}
    >
      {isUser ? (
        <Text size='xs' className={cn(classes.userMessage, classes.textBreak)}>
          {message.content}
        </Text>
      ) : (
        <Box className={classes.textBreak}>
          <AssistantMarkdown>{message.content}</AssistantMarkdown>
        </Box>
      )}
    </Paper>
  );
});
